import React, { useContext, useEffect } from 'react'
import deleteIcon from '../../images/png/deleteIcon.png'
import editIcon from '../../images/png/editIcon.png'

import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { CategorysContext } from '../../context/categorys'

const Image = styled.img`
    width: 28px;
    height:26px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 21px;
        height: 21px;
        margin-left: 0.8rem;
        
    }

`
const ImageProduct = styled.img`
    width: 48px;
    height:48px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 29px;
        height: 29px;
        margin-left: 0.8rem;
        
    }

`
const CheckBox = styled.input`

    appearance: none;
`

const TableListCategorys = ({ data, structure}) => {

    const {
        getAll,
        setShowModalEdit,
        setModalEditValue,
        setModalEditValueId,
        subCategorys,
        setModalEditImage,
        setModalEditName,
        getById,
        getSubCategorys,
        setSubCategoryName,
        animation,
        
        removeSubCategory} = useContext(CategorysContext)

    useEffect(() => {
        getAll()
        getSubCategorys()
    }, [])

    return (
        <div className='container_startpn_table_categorys'>
            <table>

                <thead className='container_startpn_table_categorys'>
                    <tr>
                        {structure?.map((item, index) => {
                            return (
                                <td key={index}>{item.name}</td>

                            )
                        })}
                    </tr>
                </thead>


                <tbody className=''>
                    {animation

                        ?
                        <tr>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>

                        </tr>
                        :

                        subCategorys?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>#{item.id}</td>
                                    <td data-toggle="modal" data-target="">{item.name}</td>
                                    <td data-toggle="modal" data-target=""> <ImageProduct src={item.image} /></td>

                                    <td data-toggle="modal" data-target="" onClick={() => { setShowModalEdit(true); setModalEditValue(item.name); setModalEditValueId(item.id); setModalEditImage(item.image); setModalEditName(item.category); getById(item.id); setSubCategoryName(item.name) }}><Image src={editIcon} /></td>
                                    <td data-toggle="modal" data-target="" onClick={() => removeSubCategory(item.id)}> <Image src={deleteIcon} /></td>

                                </tr>
                            )
                        })}



                </tbody>
            </table>
        </div>
    )
}

export default TableListCategorys